export default __webpack_public_path__ + "static/media/logo-sambada.580f0200.jpg";